import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useManufacturersApi } from "../../http/manufacturers/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteManufacturerDialogProps = {
  manufacturerId: string;
  onClose: () => void;
};

const DeleteManufacturerDialog: FC<DeleteManufacturerDialogProps> = ({ manufacturerId, onClose }) => {
  const i18n = useI18n();
  const manufacturersApi = useManufacturersApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.manufacturers.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            onclose;
            setIsSubmitting(true);
            manufacturersApi
              .deleteAdminManufacturer(manufacturerId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.manufacturers.questions.delete}
    </ModalDialog>
  );
};

export default DeleteManufacturerDialog;
